// import React from 'react';

// const SugarMill = () => {
//   return (
//     <div className="min-h-screen bg-white px-4 py-10 flex justify-center items-start">
//       <div className="w-full max-w-screen-xl lg:w-[90%] flex flex-col lg:flex-row gap-8">
//         {/* Text Content */}
//         <div className="flex-1">
//           <h1 className="text-3xl font-bold text-gray-900 mb-6">Sugar Industries</h1>
          
//           <h2 className="text-2xl font-bold text-gray-900 leading-tight">
//             Sugar Mill Construction Services by Thaheem <br /> Construction Company
//           </h2>
          
//           <p className="text-gray-700 mt-4 leading-relaxed">
//             Below is a list of our successfully completed <strong>sugar mill construction</strong> projects. We at <strong>Thaheem Construction Company</strong> are committed to provide quality <strong>sugar mill construction services</strong> at affordable rates in <strong>Pakistan</strong>. With an experienced and highly professional team we are confident to say that our company is one of the best <strong>sugar mill construction companies in Pakistan</strong>.
//           </p>

//           {/* Bullet Points */}
//           <ul className="list-disc pl-5 mt-4 text-gray-800 space-y-1">
//             <li>JDW Sugar Mills Limited</li>
//             <li>JK Sugar Mills (Pvt) Ltd</li>
//             <li>Deharki Sugar Mills (Pvt) Ltd</li>
//             <li>Ghotki Sugar Mills (Pvt) Ltd</li>
//             <li>Indus Sugar mills (Pvt) Ltd</li>
//             <li>Dewan Sugar Mills (Pvt) Ltd</li>
//           </ul>
//         </div>

//         {/* Image */}
//         <div className="flex-shrink-0 w-full lg:w-[40%]">
//           <img
//             src="/images/rafhanmaize600-1-1.jpg"
//             alt="Sugar Mill Construction"
//             className="w-full rounded shadow"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SugarMill;





import React from "react";

const UnionTower = () => {
  // Additional images for Union Tower
  const additionalImages = [
    "/images/Picture28.jpg",
    "/images/Picture29.jpg",
    "/images/Picture30.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Union Tower Sialkot</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            Union Tower is one of our landmark projects where we have executed structural works
            with precision and dedication. At <strong>PACIFIC BUILDERS (PVT) LTD</strong>, we take pride
            in delivering the highest standards of construction for large-scale developments.
          </p>
          
          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Structural works</p>
            <p><strong>Architect:</strong> Yousaf Athar Associates</p>
            <p><strong>Covered Area:</strong> 175,000 sq ft</p>
            <p><strong>Status:</strong> Ongoing</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture4.jpg"
            alt="Union Tower Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Union Tower ${index + 1}`}
              className="w-full h-auto rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default UnionTower;
